import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SkillLibraryComponent } from './skill-library/skill-library.component';

const routes: Routes = [
  {
    path: '',
    component: SkillLibraryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SkillRoutingModule {}
